import React, { Component, createRef } from "react";
import DownloadResults from "./DownloadResults";
class ImageDetectText extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = createRef();
    this.state = {
      rawText: [],
      rawJson: [],
      formsPair: '',
      tablesPair: '',
      summaryPair: '',
      itemsPair: '',
      sectionElements: {},
    };
  }

  componentDidMount() {
    this.processImageDetectText(this.props.data);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data || prevProps.file_url !== this.props.file_url) {
      this.processImageDetectText(this.props.data);
    }
  }

  drawBoundingBox(ctx, x, y, width, height) {
    ctx.beginPath();
    ctx.rect(x, y, width, height);
    ctx.lineWidth = 2;
    ctx.strokeStyle = "red";
    ctx.stroke();
  }

  processImageDetectText(data) {
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.src = this.props.file_url;

    img.onload = () => {
      // Resize canvas to match image
      canvas.width = img.width;
      canvas.height = img.height;

      // First draw the image
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, img.width, img.height);

      // Parse data if needed
      let parsedData = [];
      if (typeof data === "string") {
        try {
          parsedData = JSON.parse(data);
        } catch (err) {
          console.error("Failed to parse data:", err);
          parsedData = [];
        }
      } else if (Array.isArray(data)) {
        parsedData = data;
      }

      this.setState({ rawJson: parsedData });

      const sectionElements = {
        forms: (
          <div className="no-analysis">
            <p>FORM Analysis is Not Enabled</p>
            <p>If Image contains a FORM : Enable Checkbox and Re-Upload Image</p>
          </div>
        ),
        tables: (
          <div className="no-analysis">
            <p>TABLE Analysis is Not Enabled</p>
            <p>If Image contains a TABLE : Enable Checkbox and Re-Upload Image</p>
          </div>
        ),
        receipt: (
          <div className="no-analysis">
            <p>Receipt Analysis is Not Enabled</p>
            <p>If Image contains a Receipt : Enable Checkbox and Re-Upload Image</p>
          </div>
        ),
      };

      if (!parsedData || parsedData.length === 0) {
        this.setState({ rawText: ["No text was found"], sectionElements });
      } else {
        const rawText = parsedData.map((item, i) => {
          if (item.BlockType === "LINE") {
            const x = item.Geometry.BoundingBox.Left * img.width;
            const y = item.Geometry.BoundingBox.Top * img.height;
            const width = item.Geometry.BoundingBox.Width * img.width;
            const height = item.Geometry.BoundingBox.Height * img.height;

            this.drawBoundingBox(ctx, x, y, width, height);

            return `${item.Text} (Confidence: ${item.Confidence.toFixed(2)}%)`;
          }
          return null;
        });

        this.setState({ rawText: rawText.filter(Boolean), sectionElements });
      }
    };
  }

  render() {
    const { rawText, sectionElements } = this.state;
    const { type } = this.props;

    return (
        <>
            <canvas ref={this.canvasRef} style={{ display: "none" }} />
            {
                type === 'text'?
                    <div id="raw-text">
                        {rawText.length > 0 ? (
                            rawText.map((line, i) => (
                            <div key={i} className="text inline-text">
                                {line}
                            </div>
                            ))
                        ) : (
                            <div className="no-analysis">
                                <p>No text was found</p>
                            </div>
                        )}
                    </div>
                : type === 'form' ?
                    <div id="forms">{sectionElements?.forms}</div>
                : type === 'table' ?
                    <div id="tables">{sectionElements?.tables}</div>
                : type === 'receipt' ?
                    <div id="receipt">{sectionElements?.receipt}</div>
                :
                    <></>
            }
            <DownloadResults
                rawText={this.state.rawText}
                rawJson={this.state.rawJson}
                forms={this.state.formsPair}
                tables={this.state.tablesPair}
                items={this.state.itemsPair}
                summary={this.state.summaryPair}
            />
        </>
    )
  }
}

export default ImageDetectText;
